import { render, staticRenderFns } from "./RatingBadge.vue?vue&type=template&id=d768a6ae&"
import script from "./RatingBadge.vue?vue&type=script&lang=ts&setup=true&"
export * from "./RatingBadge.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d768a6ae')) {
      api.createRecord('d768a6ae', component.options)
    } else {
      api.reload('d768a6ae', component.options)
    }
    module.hot.accept("./RatingBadge.vue?vue&type=template&id=d768a6ae&", function () {
      api.rerender('d768a6ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/RatingBadge/RatingBadge.vue"
export default component.exports